export const DATE_FORMAT = "YYYY-MM-DDTHH:mm";

export const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const PLATFORM_INTRO_COOKIE_KEY = "wtIntroSkip";

export enum TRADE_OPERATION_TYPE {
    BUY = "Buy",
    SELL = "Sell",
}

export const GUEST_FAVOURITES_STORAGE_KEY = "trader_guest_favourites";

export const MARGIN_CALL_COOKIE_KEY = "trader_margin_call_shown";

export const SYMBOLS_IMAGES_MAP_STORAGE_KEY = "symbols_images_map";

export const TIP_RANKS_ASSETS_LIST = "tip_ranks_assets_list"

export const TRANSACTIONS_TYPES = {
    regular_deposit: "Deposit",
    deposit_cc: "Deposit",
    adjustment: "Correction",
    regular_withdrawal: "Withdrawal",
    cancel_withdrawal_request: "Withdrawal Cancellation",
    chargeback: "Correction",
    cancel_chargeback: "Correction",
    rollover_correction: "Rollover Correction",
    psp_recall: "PSP Recall",
    refer_a_friend: "Refer a Friend",
    rebate: "Rebate",
    agreement: "Agreement",
    balance_correction: "Balance Correction",
    bo_correction: "Correction",
    cancel_withdrawal: "Cancel Withdrawal",
    dealing_correction: "Dealing Correction",
    fee: "Fee",
    fee_reimbursement: "Fee Reimbursement",
    fraud_correction: "Fraud correction",
    reset_balance: "Reset Balance",
    technical_error: "Technical Error",
    verification_bonus: "Verification Bonus",
    binaryclosure: "BinaryClosure",
    competition_winner: "Competition Winner",
    swap_corrections: "Swap Corrections",
    money_transfer: "Money Transfer",
};

export const DOLLARS_SYMBOLS = {
    //USD: "US$",
    CAD: "CA$",
    AUD: "AU$",
    NZD: "NZ$",
    SGD: "S$",
    HKD: "HK$",
    MXN: "MX$",
    BND: "BN$",
    FJD: "FJ$",
    TTD: "TT$",
    JMD: "J$",
    BSD: "B$",
    KYD: "CI$",
    BBD: "Bds$",
    XCD: "EC$",
    LRD: "L$",
    SRD: "SR$",
    GYD: "G$",
    NAD: "N$",
    ZWD: "Z$",
};

export const VALID_CURRENCIES = {
    AED: "د.إ",
    AFN: "؋",
    ALL: "L",
    AMD: "֏",
    ANG: "ƒ",
    AOA: "Kz",
    ARS: "$",
    AUD: "$",
    AWG: "ƒ",
    AZN: "₼",
    BAM: "KM",
    BBD: "$",
    BDT: "৳",
    BGN: "лв",
    BHD: ".د.ب",
    BIF: "FBu",
    BMD: "$",
    BND: "$",
    BOB: "Bs.",
    BRL: "R$",
    BSD: "$",
    BTN: "Nu.",
    BWP: "P",
    BYN: "Br",
    BZD: "BZ$",
    CAD: "$",
    CDF: "FC",
    CHF: "CHF",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    CRC: "₡",
    CUP: "$",
    CVE: "Esc",
    CZK: "Kč",
    DJF: "Fdj",
    DKK: "kr",
    DOP: "RD$",
    DZD: "د.ج",
    EGP: "£",
    ERN: "Nfk",
    ETB: "Br",
    EUR: "€",
    FJD: "$",
    FKP: "£",
    FOK: "kr",
    GBP: "£",
    GEL: "₾",
    GGP: "£",
    GHS: "₵",
    GIP: "£",
    GMD: "D",
    GNF: "FG",
    GTQ: "Q",
    GYD: "$",
    HKD: "$",
    HNL: "L",
    HRK: "kn",
    HTG: "G",
    HUF: "Ft",
    IDR: "Rp",
    ILS: "₪",
    IMP: "£",
    INR: "₹",
    IQD: "ع.د",
    IRR: "﷼",
    ISK: "kr",
    JEP: "£",
    JMD: "J$",
    JOD: "د.ا",
    JPY: "¥",
    KES: "Sh",
    KGS: "с",
    KHR: "៛",
    KID: "$",
    KMF: "CF",
    KRW: "₩",
    KWD: "د.ك",
    KYD: "$",
    KZT: "₸",
    LAK: "₭",
    LBP: "ل.ل",
    LKR: "Rs",
    LRD: "$",
    LSL: "L",
    LYD: "ل.د",
    MAD: "د.م.",
    MDL: "L",
    MGA: "Ar",
    MKD: "ден",
    MMK: "Ks",
    MNT: "₮",
    MOP: "P",
    MRU: "UM",
    MUR: "₨",
    MVR: "Rf",
    MWK: "MK",
    MXN: "$",
    MYR: "RM",
    MZN: "MT",
    NAD: "$",
    NGN: "₦",
    NIO: "C$",
    NOK: "kr",
    NPR: "Rs",
    NZD: "$",
    OMR: "ر.ع.",
    PAB: "B/.",
    PEN: "S/",
    PGK: "K",
    PHP: "₱",
    PKR: "₨",
    PLN: "zł",
    PYG: "₲",
    QAR: "ر.ق",
    RON: "lei",
    RSD: "дин.",
    RUB: "₽",
    RWF: "FRw",
    SAR: "﷼",
    SBD: "$",
    SCR: "₨",
    SDG: "ج.س.",
    SEK: "kr",
    SGD: "$",
    SHP: "£",
    SLE: "Le",
    SLL: "Le",
    SOS: "Sh",
    SRD: "$",
    SSP: "£",
    STN: "Db",
    SYP: "£",
    SZL: "L",
    THB: "฿",
    TJS: "ЅМ",
    TMT: "T",
    TND: "د.ت",
    TOP: "T$",
    TRY: "₺",
    TTD: "$",
    TVD: "$",
    TWD: "NT$",
    TZS: "Sh",
    UAH: "₴",
    UGX: "Sh",
    USD: "$",
    UYU: "$U",
    UZS: "сўм",
    VES: "Bs.",
    VND: "₫",
    VUV: "Vt",
    WST: "T",
    XAF: "FCFA",
    XCD: "$",
    XOF: "CFA",
    XPF: "₣",
    YER: "﷼",
    ZAR: "R",
    ZMW: "ZK",
    ZWL: "Z$",
};

export const WEB_TRADER_ASSETS_KEYS = {
    "3M": "MMM",
    AIG: "AIG",
    Alibaba: "BABA",
    ALCOA: "AA",
    AMAZON: "AMZN",
    AMEX: "AXP",
    APPLE: "AAPL",
    ATT: "T",
    BAIDU: "BIDU",
    BOA: "BAC",
    BOEING: "BA",
    CAT: "CAT",
    CHEVRON: "CVX",
    COKE: "KO",
    CISCO: "CSCO",
    CITI: "C",
    DISNEY: "DIS",
    EBAY: "EBAY",
    EXXM: "XOM",
    FERRARI: "RACE",
    GM: "GM",
    GOLDSACHS: "GS",
    GOOGLE: "GOOGL",
    IBM: "IBM",
    INTEL: "INTC",
    JPM: "JPM",
    MA: "MA",
    MCDON: "MCD",
    MSFT: "MSFT",
    Netflix: "NFLX",
    PFIZER: "PFE",
    ADOBE: "ADBE",
    QUALCOMM: "QCOM",
    MACYS: "M",
    NVIDIA: "NVDA",
    Spotify: "SPOT",
    TESLA: "TSLA",
    TEVA: "TEVA",
    WMART: "WMT",
    Visa: "V",
    Vipshop: "VIPS",
    TILRAY: "TLRY",
    WellFargo: "WFC",
    UBER: "UBER",
    BeyondMeat: "BYND",
    Ford: "F",
    AMD: "AMD",
    MODERNA: "MRNA",
    ZOOM: "ZM",
    NIKOLA: "NKLA",
    INOVIO: "INO",
    NOVAVAX: "NVAX",
    AAL: "AAL",
    AIRBNB: "ABNB",
    PayPal: "PYPL",
    "AMAZON.m": "AMZN",
    "GOOGLE.m": "GOOGL",
    COIN: "COIN",
    META: "META",
    CCU: "CCU",
    Dropbox: "DBX",
    BNTX: "BNTX",
    NIO: "NIO",
    PLUG: "PLUG",
    BLDP: "BLDP",
    SNAP: "SNAP",
    NIKE: "NKE",
    LOCKHEED: "LMT",
    BBVA: "BBVA",
    REPSOL: "REPYY",
    //Amadeus: "AMADY",
    BSANMD: "BSANMD",
    //CaixaBank: "CAIXY",
    BAYER: "BAYRY",
    "BORUS-DORT": "BVB",
    BMW: "BMWYY",
    //ALLI: "ALIZY",
    COMMBK: "CMRZF",
    DBFRA: "DB",
    Lufthansa: "DLAKY",
    SIE: "SIEGY",
    VOWGEN: "VWAGY",
    ADS: "ADDYY",
    ABB: "ABBNY",
    HM: "HNNMY",
    DPW: "DHLGY",
    SAP: "SAP",
    "B.PETROL": "BP",
    VODAFONE: "VOD",
    ENI: "E",
    Sanpaolo: "ISNPY",
    Juventus: "JVTSF",
    //LVMH: "LVMUY",
    TOTAL: "TTE",
    RoyalShell: "SHEL",
    //ALSTOM: "ALSMY",
    //AXA: "AXAHY",
    //AIRLIQUID: "AIQUY",
    BNP: "BNPQY",
    AIRBUS: "EADSY",
    //CARREFOUR: "CRRFY",
    RENAULT: "RNLSY",
    "UNIBAIL-R": "UNBLF",
    VALLOUREC: "VLOWY",
    //Heineken: "HEINY",
    CELLNEX: "CLNXF",
    // ACS: "ACSAY",
    ENAGAS: "ENGGY",
    NEL: "NLLSF",
    Nestle: "NSRGY",
    ALLEGRO: "ALGRY",
    BOROUGE: "BOROUGE",
    MELI: "MELI",
    BANCOCHILE: "BCH",
    SQM: "SQM",
    QUINENCO: "QUCOF",
    SIMEC: "SIM",
    TECOM: "TECOM",
    CREDITCORP: "CREDITC",
    EMAAR: "EMAAR",
    ARAMCO: "2222.SR",
    ADNOCDIST: "ADNOCDIST",
    ENBD: "ENBD",
    ETISALAT: "ETISALAT",
    "EMIRATE.DU": "EMIRATESNBD",
    GOLDFIELDS: "GFI",
    BIMBOA: "BIMBOA",
    BBAJIOO: "BBAJIOO",
    VESTA: "VTMX",
    GAPB: "GAPB",
    GCC: "GCC",
    GFNORTEO: "GFNORTEO",
    BAVA: "BAVA",
    ADCB: "ADCB",
    ADIB: "ADIB",
    CTT: "CTT",
    ADAVIATION: "ADAVIATION",
    CBKD: "CBKD",
    QAMC: "QAMC",
    QIBK: "QIBK",
    QNBK: "QNBK",
    QUALITAS: "QUALITAS",
    TIGO: "TIGO",
    PORSCHE: "POAHY",
    Salik: "SALIK",
    UNITY: "UNITY",
    BURJEEL: "BURJEEL",
    AIRA: "AIRA",
    DANA: "DANA",
    FERTIGLOBE: "FERTIGLOBE",
    JNJ: "JNJ",
    FAB: "FAB",
    "ABQK.QA": "ABQK",
    SPCE: "SPCE",
    XPENG: "XPEV",
    ALDAR: "ALDAR",
    BKDB: "BKDB",
    "CCI.US": "CCI",
    "AMT.US": "AMT",
    "IRM.US": "IRM",
    "EQIX.US": "EQIX",
    "DLR.US": "DLR",
    "BRES.QA": "BRES",
    BTEL: "BTEL",
    DISB: "DISB",
    OTEL: "OTEL",
    "QATR.QA": "QATR",
    "QNCD.QA": "QNCD",
    TAQA: "TAQA",
    "UDCD.QA": "UDCD",
    "VFQS.QA": "VFQS",
    Empower: "EMPOWER",
    CBD: "CBD",
    ADPORTS: "ADPORTS",
    BAYANAT: "BAYANAT",
    DFM: "DFM",
    LTM: "LTM",
    TSM: "TSM",
    DEWAA: "DEWA",
    QFLS: "QFLS",
    "EVO.ST": "EVO",
    QEWC: "QEWC",
    "TABREED.AE": "TABREED",
    RJHI: "1120.SR",
    NCB: "1180.SR",
    SAFCO: "SAFCO",
    MAADEN: "1211.SR",
    SABIC: "2010.SR",
    ALARKAN: "ALARKAN",
    JOMAR: "JOMAR",
    BYD: "BYDDY",
    "IHC.EM": "IHC",
    BRKa: "BRK.A",
    C3AI: "AI",
    SAMSUNG: "SSNLF",
    KAKAOBANK: "KAKAOBANK",
    SKHYNIX: "HXSCL",
    TOYOTA: "TM",
    SONY: "SONY",
    MFG: "MFG",
    NMR: "NMR",
    MITSUBISHI: "MSBHY",
    TATA: "TTM",
    HYUNDAI: "HYMTF",
    PETROBRAS: "PBR",
    LCID: "LCID",
    RIVN: "RIVN",
    AMR: "AMR",
    ADNOCGAS: "ADNOCGAS",
    "ALG.KW": "ALG",
    "BOUBYAN.KW": "BOUBYAN",
    KFH: "KFH",
    "NBK.KW": "NBK",
    ZAIN: "ZAIN",
    BURGANBANK: "BURGAN",
    "ABK.KW": "ABK",
    "IPG.KW": "IPG",
    AYRE: "AYRE",
    CABL: "CABL",
    RAKUTEN: "RKUNY",
    ALANSARI: "ALANSARI",
    "JAZEERA.KW": "JAZEERA",
    GD: "GD",
    NOC: "NOC",
    RTX: "RTX",
    BAES: "BAESY",
    UPST: "UPST",
    BDX: "BDX",
    BLDN: "BLDN",
    COMB: "COMB",
    MARK: "MARK",
    CRM: "CRM",
    CRWD: "CRWD",
    PANW: "PANW",
    SNOW: "SNOW",
    PLTR: "PLTR",
    ORCL: "ORCL",
    TEAM: "TEAM",
    DDOG: "DDOG",
    "SBC.JP": "SFTBY",
    PRESIGHT: "PRESIGHT",
    ASML: "ASML",
    MU: "MU",
    AVGO: "AVGO",
    LMND: "LMND",
    VFS: "VFS",
    ALB: "ALB",
    NVO: "NVO",
    ASE: "ASX",
    ARM: "ARM",
    LTHM: "LTHM",
    LAC: "LAC",
    SGML: "SGML",
    "7010.SR": "7010.SR",
    "MEZA.QA": "MEZA",
    PhilpMoris: "PM",
    "DUBAI.TAXI": "DTC",
    "LRCX.US": "LRCX",
    "LLY.US": "LLY",
    "BHA.IN": "BHARTIARTL",
    HONDA: "HMC",
    INFOSYS: "INFY",
    POSCO: "PKX",
    TCS: "TCS",
    "RDDT.US": "RDDT",
    PARKIN: "PARKIN",
    UBSG: "UBS",
    NOVN: "NVS",
    SCMN: "SCMN",
    ZURN: "ZURVY",
    UHR: "UHR",
    BRKb: "BRK.B",
    SPINNEYS: "SPINNEYS",
    GME: "GME",
    "AMAT.US": "AMAT",
    "NMDC.EM": "NMDC",
    "GE.US": "GE",
    "REL.NSE": "RELIANCE",
    "ITC.NSE": "ITC",
    "LULU.EM": "LULU",
    "MSTR.US": "MSTR",
    "QUBT.US": "QUBT",
    "MRVL.US": "MRVL",
    "TXN.US": "TXN",
    "ADI.US": "ADI",
    "NXPI.US": "NXPI",
    "MCHP.US": "MCHP",
}